<template>
	<div class="reviewOrders">

		<div class="titleRw">{{$t('other.a761')}}</div>

		<div>
			<div v-for="(item,index) in btnlist" :key="index">
				<div class="inkng">
					<div class="arewa">{{item.desc}}</div>
					<div clas="jkngvc">
						<span  v-for="(childrenItem,index02) in item.option" :key="index02" @click="handleItem(item,childrenItem,index,index02)">
							<span :class="{'inlnc':true, 'btnActive': index02 == activeList[index]}">
								{{filterDesc(childrenItem.key,index)}}
								({{childrenItem.value.length}})
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>

		<div style="padding:10px 0;">
		  <span class="arewa">{{$t('other.a762')}}：</span>
          <el-switch
            v-model="userLimited"
            @change="updataUserLimit()"
            :active-text="$t('other.a763')"
            :inactive-text="$t('other.a5')">
            </el-switch>
          
       </div>

		<div class="tgbh">
           <span>{{$t('other.a764')}}:
               <el-input size="medium" style="width:250px" v-model="orderValue" :placeholder="$t('other.a764')"></el-input>
           </span>
           <span style="margin:0 15px;">{{$t('other.a64')}}：
               <el-select v-model="sortValue" :placeholder="$t('other.a50')">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
           </span>
       </div> 
	   
		<div>
			<Order-list :orderList="orderList" :amount="amount" @updataOrderList='updataOrderList' :activeShopId='activeShopId'></Order-list>
		</div>
		<div class="Pager">
			<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-sizes="[10, 40, 50, 100, 200]"
			:page-size="offset"
			layout=" total,sizes, prev, pager, next, jumper"
			:total="amount">
			</el-pagination>
		</div>
		
	
	</div>
</template>

<script>
import Dialog from '../../../components/dialog/dialog.vue'
import shopaccessApi from "../../../api/moudles/shopaccess";
import CustomerOrder from './components/dialog'
import OrderList from './components/orderList'
import utils from '../../../utils/utils.js'
import {JudegeBindStore, JudegeSensitive} from '../../../utils/toolFun'
import Condition from '../../../components/condition'
import orderApi from '../../../api/moudles/order'
import {COUNTRY_AREA} from '../../../config/config.js'
import userStoreItems from '../../../api/moudles/userStoreItems'
import {mapState,mapActions,mapMutations} from 'vuex'
import api from '../../../api/api'
import newOrders from '../../../api/moudles/newOrders'
import jsonp from '../../../api/jsonp'
import config from '../../../config/config'
import shopaccess from '../../../api/moudles/shopaccess'

	export default {
		data() {
			return {
				reviewParams:{},
    			userLimited:false,
				mapList:[],
				activeObj:[0,0],
				activeShopId:-1,
				btnlist:[],
				activeList:[],
				exchangeRate:[],
				amount:0,
				offset:50,
				page:1,
				currentPage:1,
				orderValue:null,
				sortValue:0,
				options:[{
					label:this.$t('other.a766'),
					value:0,
				},{
					label:this.$t('other.a767'),
					value:1,
				},{
					label:this.$t('other.a768'),
					value:2,
				},{
					label:this.$t('other.a769'),
					value:3,
				},]
			}
		},
		components:{
			OrderList
		},
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				userInfo: state => state.shopaccess.userInfo,
				scrollLocation:state => state.common.scrollLocation,
			}),

			orderList(){
				let list=[]
				
				if(this.btnlist[7]){
					list=this.btnlist[7].option[this.activeList[7]].value
				}
				if(this.btnlist[8]){
					list=this.btnlist[8].option[this.activeList[8]].value
				}

				if(this.orderValue){
					let value=JSON.parse(JSON.stringify(this.orderValue)).trim()
					let target = []
					if(value.includes(' ')){
						value = value.split(' ')
						target=list.filter(item => value.includes(item.orderId))
						list=target.length>0 ? target : []
					}else{
						target=list.find(item => item.orderId == value)
						list=target ? [target] : []
					}
				}


				this.amount=list.length


				list.sort((a, b) => {
					if (this.sortValue == 0) {
						return new Date(b.createTime) - new Date(a.createTime)
					}
					if (this.sortValue == 1) {
						return new Date(a.createTime) - new Date(b.createTime)
					}

					if (this.sortValue == 2) {
						return new Date(b.shipByDate) - new Date(a.shipByDate)
					}
					if (this.sortValue == 3) {
						return new Date(a.shipByDate) - new Date(b.shipByDate)
					}
				})
				let list2=list.slice((this.page-1)*this.offset,this.page*this.offset)

				console.log('list2',list2)
				return list2
				
			},
	
			
			
		},
		watch:{},

		mounted(){
			setTimeout(() => {
				window.addEventListener('scroll', this.menu)
			},1000)
		},
		created(){
			this.reviewParams.end=null
			this.reviewParams.start=null
			this.reviewParams.orderId=null
			this.reviewParams.hasStoreItem=true
			this.reviewParams.orderType=1
			this.reviewParams.offset=null
			this.reviewParams.page=0
			this.reviewParams.hidden=null
			this.reviewParams.shopIds=this.userInfo.shopIds
			this.reviewParams.platformType=null
			this.reviewParams.sortType=1
			this.reviewParams.storeIds=this.userInfo.storeIds
			this.reviewParams.userId=this.userId
			this.getExchangeRate()
			this.getUserLimte()
			this.getOrderData()
		},


		activated() {
			this.updataOrderList()
			console.log("1激活activated钩子函数");
			document.documentElement.scrollTop=this.scrollLocation
			
		},

		beforeRouteLeave (to, from, next) {//记录离开时的位置
			let position = window.scrollY
			console.log('position',position)
			this.markScrollLocation(position)
			next()

		},
		methods: {
			...mapMutations('common', [
				'storageOrderInfo',
				'storageOrderInfoCopy',
				'markScrollLocation'
			]),

			updataUserLimit(){
				this.userLimited=!this.userLimited
				if(this.userLimited){
					this.$confirm(this.$t('other.a770'), this.$t("other.a142"), {
					confirmButtonText: this.$t('other.a235'),
					cancelButtonText: this.$t('other.a146'),
					type: 'warning'
					}).then(() => {
						this.updatauserLimitedCopy({
							auditLimit:false,
							userId:this.userId
						})
					})
				}else{
					this.$confirm(this.$t('other.a771'), this.$t("other.a142"), {
					confirmButtonText: this.$t('other.a235'),
					cancelButtonText: this.$t('other.a146'),
					type: 'warning'
					}).then(() => {
						this.updatauserLimitedCopy({
							auditLimit:true,
							userId:this.userId
						})
					})
				}
				
				
			},

			updatauserLimitedCopy(params){
				api
				.updateUserAuditLimit(params)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				if(res.data){
					this.$message.success(this.$t('other.a772'))
				}else{
					this.$message.warning(this.$t('other.a773'))
				}
				
				this.getUserLimte()
				}else{
				this.$message.warning(res.msg)
				}
				})
			},

			getUserLimte(){
				api
				.getUserAuditLimit({
					userId:this.userId
				})
				.then(res => {
				if(res.code === 200 ){
				console.log('desc85',res.data)
				this.userLimited=res.data
				
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			menu(){
				//变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;

				this.scrollTop=scrollTop
				
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.offset=parseInt(`${val}`)
			
			},
			getExchangeRate(){
				shopaccessApi
				.getcurrencyall({
				userId: this.userId
				})
				.then(res => {
				this.exchangeRate=res.data
				});
			},
			updataOrderList(data){
				this.showLoading()
				setTimeout(() => {
					orderApi
					.queryAllOrders(this.reviewParams)
					.then(res => {
						if(res.code == 200){
							console.log('更配数组',res.data.orders)
							let params=res.data.orders
							let type=-1
							this.mapList.forEach((key,i) => {
								if(i > type ){
									for(let [ky] of key){
										key.set(ky,[])
										key.set('null',params)
									}
								}	
							})
							params.forEach(p => {
								p.checked=false
								p.goodsType=0
								p.country=p.country ? p.country.toUpperCase() : null
								p.returnOrder=p.storeFlagId !== 0 && p.storeFlagDes !== null ? true :false
								//canAudit  0:已绑定,1未绑定,2,订单内有不同仓库的产品
								p.canAudit=JudegeBindStore(p.items) 
								
								// if(p.orderId == 'PO-211-15370121831032483'){
								// console.log(p)
								// console.log(p.orderId)
								// console.log(999999)
								// }
								// console.log(p.items[0].storeItem)
								p.storeIdCopy=null
								p.targetStoreId=p.canAudit == 0 ? p.items[0]?p.items[0].storeItem.storeId:'null' : p.canAudit
								p.createTime=utils.getCurrnetTime(p.createTime)
								p.shipByDate=utils.getCurrnetTime(p.shipByDate)
								p.distributeStatus=p.platform=='DXS' ? 0 : p.distributeStatus
								p.sensitive=p.canAudit == 0 ? JudegeSensitive(p.items) : false
								//国家地区
								if(type < 0){
									this.mapList[0].set(p.country,this.getMap(this.mapList[0],p.country,p))
								}
								//平台类型 SHOPEE LAZADA  DTB(分销订单)  DXS(自建手工单)
								if(type < 1){
									this.mapList[1].set(p.platform,this.getMap(this.mapList[1],p.platform,p))
								}
								//店铺选项
								if(type < 2){
									this.mapList[2].set(p.shopId,this.getMap(this.mapList[2],p.shopId,p))
								}
								//货物类型
								if(type < 3){
									this.mapList[3].set(p.sensitive,this.getMap(this.mapList[3],p.sensitive,p))
								}
								//是否分销订单  0普通订单 1包含分销产品 2全部是分销产品
								if(type < 4){
									this.mapList[4].set(p.distributeStatus,this.getMap(this.mapList[4],p.distributeStatus,p))
								}
								//是否退审订单 
								if(type < 5){
									this.mapList[5].set(p.returnOrder,this.getMap(this.mapList[5],p.returnOrder,p))
								}
								//是否已绑定
								if(type < 6){
									this.mapList[6].set(p.targetStoreId,this.getMap(this.mapList[6],p.targetStoreId,p))
								}
								//订单的显示隐藏 
								if(type < 7){
									this.mapList[7].set(p.hidden,this.getMap(this.mapList[7],p.hidden,p))
								}
								//物流状态 
								if(type < 8){
									this.mapList[8].set(((p.trackingNo&&p.trackingNo!=''||p.logistics&&p.logistics!='')?true:false),this.getMap(this.mapList[8],((p.trackingNo&&p.trackingNo!=''||p.logistics&&p.logistics!='')?true:false),p))
								}

							})

							console.log('mapList',this.mapList)

							for(let i=0;i<this.btnlist.length;i++ ){
								let list=this.btnlist[i].option
								for(let k=0;k<list.length;k++ ){
									list[k].value=this.mapList[i].get(list[k].key)
								}
							}
							let activeList=this.activeList

							for(let k =0;k<activeList.length;k++){
								if(activeList[k] !== 0){
									let firstItem=null
									let seoonitem=this.btnlist[k].option[activeList[k]]
									let indexOne=k
									let indexTwo=activeList[k]


									this.handleItem(firstItem,seoonitem,indexOne,indexTwo)
								}
							}
							
							
							console.log('active',this.activeObj)
						}
					})

				},200)
			},
			//显示当前第几页
			handleCurrentChange(val) {
				this.currentPage=parseInt(`${val}`)
				this.page=parseInt(`${val}`) ?  parseInt(`${val}`) : 0
				console.log('page',this.page)
				
			},
			handleItem(item,childrenItem,index,index02){
				
				if(index == 2){
					this.activeShopId=childrenItem.key == 'null' ? -1 :childrenItem.key
				}
				this.$set(this.activeList,index,index02)
				console.log('activeList',this.activeList)
				console.log(childrenItem.value,index)
				this.orderClassification(childrenItem.value,index)
				this.orderdata=this.btnlist[7].option[this.activeList[7]].value
			},
			//get出选中状态订单数据
			getMapOrderData(){
				let list=this.activeList
				let orderList=[]
				for(let i=0;i<list.length;i++ ){
					if(list[i]){
						orderList.push(this.btnlist[i].option[list[i]].value)
					}
				}

				console.log('orderList',orderList)
			},
			//获取待审核订单数据
			getOrderData(){
				this.showLoading()
				// alert(11)
				// this.reviewParams.orderId = 'PO-211-04731494008871351'
				orderApi
				.queryAllOrders(this.reviewParams)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				for(let o = 0;o<res.data.orders.length;o++){
					if(res.data.orders[o].orderId=='577116139787160459'){
				console.log('desc222',res.data.orders[o])
					}
				}
				this.amount=res.data.orders.length
				this.mapList=[]
				this.btnlist=[]
				for(let i=0;i<9;i++ ){
					this.mapList.push(new Map())
					this.mapList[i].set('null',[])
					this.activeList.push(0)
					if(i==1){
						this.mapList[i].set('SHOPEE',[])
						this.mapList[i].set('LAZADA',[])
						this.mapList[i].set('DXS',[])
					}

					if(i == 2){
						let shopsInfo=utils.getAllshop()
						for (let k = 0; k < shopsInfo.length; k++) {
							if(shopsInfo[k].value){
								this.mapList[i].set(shopsInfo[k].value,[])
							}
							
						}
					}

					if(i==3){
						this.mapList[i].set(false,[])
						this.mapList[i].set(true,[])
					}

					if(i==4){
						this.mapList[i].set(0,[])
						this.mapList[i].set(1,[])
						this.mapList[i].set(2,[])
					}
					if(i==5){
						this.mapList[i].set(false,[])
						this.mapList[i].set(true,[])
					}
					if(i==6){
						
						this.mapList[i].set(1,[])
						this.mapList[i].set(2,[])
					}

					if(i==7){
						this.mapList[i].set(false,[])
						this.mapList[i].set(true,[])
					}
					if(i==8){
						this.mapList[i].set(true,[])
						this.mapList[i].set(false,[])
					}

				}
				this.activeList[7]=1
				this.orderClassification(res.data.orders,-1)
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			getRmbPaid(pri,cur){
				if(!cur){
					return '--'
				}
				let rate=this.exchangeRate.find(item => item.country === cur)
				rate=rate ? Number(rate.rate) : 1
				let price=pri*rate
				return price.toFixed(2)
			},
			getTotalSupplyPrice(items,platform){
				let price=0
				items.forEach(p => {
					if(platform == 'TEMU'){
						if(p.storeItem){
							price+=p.storeItem.cost
						}
					}else{
						if(p.storeItem && p.storeItem.putAway && !p.storeItem.component && p.storeItem.children){
							price+=p.storeItem.children[0].price
						}
					}
				})
				return price
			},

			//订单分类
			 orderClassification(payload,type){
				 this.btnlist=[]
				 let that=this
				 let orderList=payload
				 this.mapList.forEach((key,i) => {
					if(i > type ){
						for(let [ky] of key){
							key.set(ky,[])
							key.set('null',orderList)
						}
					}	
				})
				 orderList.forEach(p => {
					p.country=p.country ? p.country.toUpperCase() : null
					p.rmbPaid=that.getRmbPaid(p.escrowAmount,p.country)
					p.totalSupplyPrice=that.getTotalSupplyPrice(p.items,p.platform)
					// p.grossProfit=(p.rmbPaid-p.totalSupplyPrice-4)
					p.grossProfit=p.rmbPaid<157?(p.rmbPaid-p.totalSupplyPrice+20):(p.rmbPaid-p.totalSupplyPrice)
					p.checked=false
					p.goodsType=0
					//canAudit  0:已绑定,1未绑定,2,订单内有不同仓库的产品
					p.returnOrder=p.storeFlagId !== 0 && p.storeFlagDes !== null ? true :false
					p.canAudit=JudegeBindStore(p.items) 
					p.storeIdCopy=null
					
					p.returnOrder=p.storeFlagDes && p.storeFlagId ? true :false
					p.targetStoreId=p.canAudit == 0 ? p.items[0]?p.items[0].storeItem.storeId:'null' : p.canAudit
					p.createTime=utils.getCurrnetTime(p.createTime)
					p.shipByDate=utils.getCurrnetTime(p.shipByDate)
					p.distributeStatus=p.platform=='DXS' ? 0 : p.distributeStatus
					p.sensitive=p.canAudit == 0 ? JudegeSensitive(p.items) : false
					
					
					//国家地区
					if(type < 0){
						this.mapList[0].set(p.country,this.getMap(this.mapList[0],p.country,p))
					}
					//平台类型 SHOPEE LAZADA  DTB(分销订单)  DXS(自建手工单)
					if(type < 1){
						this.mapList[1].set(p.platform,this.getMap(this.mapList[1],p.platform,p))
					}
					//店铺选项
					if(type < 2){
						this.mapList[2].set(p.shopId,this.getMap(this.mapList[2],p.shopId,p))
					}
					//货物类型
					if(type < 3){
						this.mapList[3].set(p.sensitive,this.getMap(this.mapList[3],p.sensitive,p))
					}
					//是否分销订单  0普通订单 1包含分销产品 2全部是分销产品
					if(type < 4){
						this.mapList[4].set(p.distributeStatus,this.getMap(this.mapList[4],p.distributeStatus,p))
					}
					//是否退审订单 
					if(type < 5){
						this.mapList[5].set(p.returnOrder,this.getMap(this.mapList[5],p.returnOrder,p))
					}
					//是否已绑定
					if(type < 6){
						this.mapList[6].set(p.targetStoreId,this.getMap(this.mapList[6],p.targetStoreId,p))
					}
					//订单的显示隐藏 
					if(type < 7){
						this.mapList[7].set(p.hidden,this.getMap(this.mapList[7],p.hidden,p))
					}
					//物流状态 
					if(type < 8){
						this.mapList[8].set(((p.trackingNo&&p.trackingNo!=''||p.logistics&&p.logistics!='')?true:false),this.getMap(this.mapList[8],((p.trackingNo&&p.trackingNo!=''||p.logistics&&p.logistics!='')?true:false),p))
					}

				 });

				 const title={
					0:this.$t('other.a776'),
					1:this.$t('other.a595'),
					2:this.$t('other.a774'),
					3:this.$t('other.a775'),
					4:this.$t('other.a777'),
					5:this.$t('other.a778'),
					6:this.$t('other.a779'),
					7:this.$t('other.a780'),
					8:"物流方式",
				}

				this.mapList.forEach((key,i) => {
					let list=[]
					key.forEach((item,value) => {
						list.push({
							key:value,
							value:item
						})
					})
					this.btnlist.push({
						desc:title[i],
						option:list
					})
				})

				this.getMapOrderData()

				 console.log('mapList',this.mapList)
				 console.log('btnlist',this.btnlist)
			 },

			 getMap(mapList,key,p){
				let list=mapList.get(key)
				
				if(p.orderId == 'PO-211-20855788196393832'){
					console.log(key)
				console.log(list)
				console.log('----3333---')
					}
				if(list == null || list == undefined){
					list=[]
				}
				list.push(p)
				return list
				
			},

			filterDesc(id,index){
				const ORDERS_TYPE={
					0:this.$t('other.a781'),
					1:this.$t('other.a782'),
					2:this.$t('other.a254'),
				}
				let ttpDesc=null
				switch(index){
					case 0:
						ttpDesc = id == 'null' ? this.$t('other.a358') : COUNTRY_AREA[id]
						break;
					case 1:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id == 'DXS' ? this.$t('other.a783') : id
						break;
					case 2:
						ttpDesc = id == 'null' ? this.$t('other.a358') : utils.showShopNameByshopId(id) == this.$t("other.a354") ? this.$t('other.a786') :  utils.showShopNameByshopId(id)
						break;
					case 3:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id == '0' ? this.$t('other.a784') : this.$t('other.a785')
						break;	
					case 4:
						ttpDesc = id == 'null' ? this.$t('other.a358') : ORDERS_TYPE[id]
						break;
					case 5:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id  ? this.$t('other.a191') : this.$t('other.a192')
						break;
					case 6:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id == 1 ? this.$t('other.a787') : id == 2 ? this.$t('other.a788') : utils.showStoreName(id)
						break;
					case 7:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id  ? this.$t('other.a789') : this.$t('other.a790')
						break;	
					case 8:
						ttpDesc = id == 'null' ? this.$t('other.a358') : id  ? this.$t('other.a3349') : this.$t('other.a3350')
						break;		
					default:
						ttpDesc = id

				}
				return ttpDesc
			}


		}
	}
</script>

<style lang="scss" scoped>

.reviewOrders{
	color: #757575;

	/deep/ .el-checkbox__inner{
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	/deep/ .el-checkbox__inner::after{
		height: 13px;
		left: 6px;
		top: 0px;
		width: 6px;
	}

	.inkng{
		display: flex;
		padding-bottom: 6px;	
	}

	.Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

	.tgbh{
        display: flex;
    }

	.titleRw{
		font-size: 20px;
		font-weight: bold;
		margin: 10px 0 20px 0;
	}

	.arewa{
		font-weight: bold;
		margin-right: 15px;
		min-width: 70px;
	}

	.jkngvc{
		display: flex;
	}

	.inlnc{
		display: inline-block;
		min-width: 60px;
		text-align: left;
		margin-right:8px;
		border: 1px solid #eee;
		border-radius: 4px;
		padding: 3px 8px;
		cursor: pointer;
	}

	.btnActive{
		color: #fff;
		background-color: #409eff;
	}

	

	
}

	


</style>
